import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {IconButton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';

import Alert, {useAlert} from 'components/snacks/Alert';

import Services from '../services/Services';
import Tickets from '../tickets/Tickets';

import UserInfo from './UserInfo';
import LastNews from './LastNews';

import {indexHeader} from 'utils/DataBase';
import {getHomePage, confirmInfo} from 'api/Api';
import Carousel from 'react-material-ui-carousel'
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const Index = (props) => {
    const [info, setInfo] = useState();
    const [number, setNumber] = useState([0, 0, 0]);
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [acc, setAcc] = useState({has_acc: false, detail: {remain: 0}});
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [helpModal, setHelpModal] = useState(false);

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    useEffect(() => {
        setLoading(true);
        getHomePage((isOk, data) => {
            if (isOk) {
                const isHelpModalActive = localStorage.getItem('isHelpModalActive');
                if(!isHelpModalActive || isHelpModalActive !== 'false'){
                    setHelpModal(true)
                }
                if (data.user_info.is_confirm === 0) {
                    setTimeout(() => {
                        setShowConfirmModal(true);
                    }, 1000)
                }
                else {
                    setShowConfirmModal(false);
                }
                setInfo(data.user_info);
                setNumber(() => [
                    data.ticket_count,
                    data.service_count,
                    data.factor_count
                ]);
                setData(data);
                setLoading(false);
                setAcc(data.acc_info);
                localStorage.setItem(
                    'user_info',
                    JSON.stringify(data.user_info)
                );
            } else {
                setLoading(false);
                alertStore.AddAlert({
                    key: 'empty',
                    message: data,
                    severity: 'error',
                    auto_hide: true
                });
            }
        });
    }, []);
    const confirm_info = () => {
        setConfirmLoading(true);
        confirmInfo((isOk, msg) => {
            setConfirmLoading(false);
            if (isOk) {
                alertStore.AddAlert({
                    key: 'empty',
                    message: "اطلاعات شما با موفقیت ثبت شد",
                    severity: 'success',
                    auto_hide: true
                });
                setShowConfirmModal(false);
                window.location.reload();
            } else {
                alertStore.AddAlert({
                    key: 'empty',
                    message: msg,
                    severity: 'error',
                    auto_hide: true
                });
            }
        })
    }


    useEffect(() => {
        if (showConfirmModal === true) {
            setTimeout(() => {
                if (showConfirmModal === true) {
                    setShowConfirmModal(false)
                }
            }, 14000)
        }
    }, [showConfirmModal])

    useEffect(() => {
        console.log(helpModal)
        if (helpModal === true) {
            localStorage.setItem('isHelpModalActive', false)
        }
    }, [helpModal])
    var items = [
        {
            name: "#1",
            src: "/assets/media/help/1.jpg"
        },
        {
            name: "#2",
            src: "/assets/media/help/2.jpg"
        },
        {
            name: "#3",
            src: "/assets/media/help/3.jpg"
        }
    ];
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        width: {
            lg: '50%',
            xs: '85%'
        },
    };
    const handleClose = () => setHelpModal(false);
    return (
        <React.Fragment>
            {loading ? (
                <div
                    className={'d-flex justify-content-center align-items-center'}
                    style={{
                        position: 'fixed',
                        width: '100%',
                        height: '100%',
                        left: '0',
                        top: '0'
                    }}
                >
                    <Box sx={{display: 'flex', marginLeft: '20px'}}>
                        <CircularProgress/>
                    </Box>
                    <h1>در حال بارگذاری...</h1>
                </div>
            ) : (
                <>
                    <div className="row g-5 g-xl-8">
                        {indexHeader.map((item, index) => (
                            <div
                                className={`col-xl-3`}
                                key={index}
                            >
                                <Link
                                    to={
                                        index === 0
                                            ? '/tickets'
                                            : index === 1
                                                ? '/services'
                                                : '/factors'
                                    }
                                    className={
                                        'card hoverable card-xl-stretch ' + `${item.bg}`
                                    }
                                    style={{
                                        backgroundImage:
                                            'linear-gradient(to right, #00000036, #0000)'
                                    }}
                                >
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <div className={'d-flex flex-column align-items-start'}>
                                            {item.svg}
                                            <div className="text-white fw-bolder fs-2 mb-2 mt-5">
                                                {item.title}
                                            </div>
                                        </div>
                                        <div className="fw-bold text-white f-4">
                                            {number[index]}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                        <div className="col-xl-3">
                            <Link
                                to={'/wallet'}
                                className={'card hoverable card-xl-stretch bg-info'}
                                style={{
                                    backgroundImage:
                                        'linear-gradient(to right, #00000036, #0000)'
                                }}
                            >
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <div className={'d-flex flex-column align-items-start'}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="35"
                                            height="35"
                                            fill="#fff"
                                            className="bi bi-wallet"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z"/>
                                        </svg>
                                        <div className="text-white fw-bolder fs-3 mb-2 mt-5">
                                            موجودی کیف پول
                                        </div>
                                    </div>
                                    <div className="fw-bold text-white f-2 direction-ltr">
                                        {acc.has_acc ? Number(acc.detail.remain).toLocaleString() : '0'}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="pt-2 section-h">
                        <div className="row mt-3">
                            <div className="col-12 col-lg-9">
                                <Services
                                    serviceList={data.services}
                                    serviceLength={number[1]}
                                    sendApi={false}
                                />
                                <div className="mt-7">
                                    <Tickets
                                        ticketList={data.tickets}
                                        ticketLength={number[0]}
                                        sendApi={false}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-3">
                                {info ? <UserInfo
                                    fName={info.first_name}
                                    lName={info.last_name}
                                    company={info.company}
                                    address={info.address}
                                    email={info.email}
                                    isConfirm={info.is_confirm}
                                    customerType={info.customer_type}
                                /> : ''}
                                <div className="mt-7">
                                    <LastNews news={data.blog}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        <Alert
                            alerts={alertStore.alert}
                            close={alertStore.RemoveAlert}
                            timeout={alert_timeout}
                        />
                    }
                    <Modal
                        open={helpModal}
                        onClose={(event, reason) => {
                            if (reason !== 'backdropClick') {
                                handleClose();
                            }
                        }}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={modalStyle} className={'border-none normal-shadow rounded mx-auto'}>
                            <Typography id="modal-modal-title" variant="h6" component="h2" className={'border-bottom pb-3'}>
                                <span>خرید ترافیک اضافه</span>
                                <IconButton
                                    onClick={handleClose}
                                    style={{ position: 'absolute', top: 8, left: 8 }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Typography>
                            <p className={'p-3 bg-primary rounded-lg text-white mt-3'}>به منظور حفظ پایداری و ارتقای کیفیت خدمات، از تاریخ 20 فروردین 1404، در صورت اتمام ترافیک سرور، دسترسی شما به اینترنت سرور محدود خواهد شد و برای ادامه استفاده، باید بسته ترافیکی خریداری شود. لازم به ذکر است بسته های ترافیک به دوره های بعدی قابل انتقال می باشد</p>
                            <Carousel
                                NextIcon={1}
                                PrevIcon={2}>
                                {
                                    items.map( (item, i) =>
                                        <div style={{
                                            aspectRatio: '2/1'
                                        }}>
                                            <img src={item.src} className={'w-100'} alt={item.name}/>
                                        </div> )
                                }
                            </Carousel>
                        </Box>
                    </Modal>
                </>
            )}
        </React.Fragment>
    );

};
export default Index;
